import React, {useState, useEffect, useRef, useMemo} from 'react'
import {Image, Space, PreviewGroup, Modal, Button as BCButton, Tag} from '@bedrock/components'
import {ChevronRight, InfoCircle, Play, RotateRight} from '@bedrock/icons-react'
import {useMemoizedFn} from 'ahooks'
import {
  ResponseString,
  outsourceContentMarketQueryGenUpdateDataPageUrlForSupplier,
  outsourceContentMarketQueryGetDemandWorkInfo, DemandWorkInfoVo
} from 'services/api';
import { openIframe } from "@mpc/common/src/features/utils";
import classNames from 'classnames/bind'
import styles from './index.less'

const cx = classNames.bind(styles)

type UploaderMarketingWorks = {
  detail: any;
  onDataChange?: (data: DemandWorkInfoVo) => void;
}

// 营销策划上传作品
export default function UploaderMarketingWorks(props: UploaderMarketingWorks) {
  const {
    detail,
    onDataChange
  } = props;
  const [isDisabledRefresh, setIsDisabledRefresh] = useState(false)
  const [workNumInfo, setWorkNumInfo] = useState<DemandWorkInfoVo>({
    num: 0,
    attach_flag: 0
  })
  const handleGotoUploadWork = useMemoizedFn(() => {
    outsourceContentMarketQueryGenUpdateDataPageUrlForSupplier({
      demand_id: detail?.root_id,
      case_demand_id: detail?.id
    }).then((result: ResponseString) => {
      if (result.code === 1) {
        openIframe(result?.data)
      }
    })
  })

  const getWorkNum = useMemoizedFn(() => {
    setIsDisabledRefresh(true)
    outsourceContentMarketQueryGetDemandWorkInfo({ case_demand_id: detail?.id }).then((result: any) => {
      if (result?.code === 1) {
        setWorkNumInfo(result?.data)
        onDataChange?.(result?.data)
      }
    }).finally(() => {
      setIsDisabledRefresh(false)
    })
  })
  useEffect(() => {
    if (detail?.id) {
      getWorkNum()
    }
  }, [detail?.id])

  return <div className={cx('uploader-marketing-works')}>
    <BCButton type='checked' onClick={handleGotoUploadWork} suffixIcon={<ChevronRight/>}>
     {detail?.$contentStructured ? '前往上传作品/下载作品记录' : '前往上传作品' }
    </BCButton>
    <div style={{margin: '0px 8px'}}>
      (已上传<b style={{margin: '0px 4px'}}>{workNumInfo?.num || 0}</b>个作品)
    </div>
    {workNumInfo?.attach_flag === 1 &&
        <Tag size={'xSmall'} color={'light-red'} icon={<InfoCircle/>} text={'稿件异常'} style={{marginLeft: '8px'}}/>}
    <BCButton
        style={{marginLeft: '8px'}}
        onClick={getWorkNum}
        type="link"
        icon={<RotateRight/>} loading={isDisabledRefresh}>刷新</BCButton>
  </div>
}
